<template>
  <div class="q-composite-container">
    <div class="q-toolbar">
      <div class="q-toolbar-buttons">
        <q-button
          class="q-toolbar-btn"
          :style="firstButtonStyle"
          @click="newComposite"
        >
          <font-awesome-icon :icon="['fas', 'plus']"/>
        </q-button>
        <q-button
          v-if="getPermissions('DELETE')"
          v-show="hasSelection"
          class="q-toolbar-btn"
          @click="deleteDialog = true"
        >
          <font-awesome-icon :icon="['fas', 'trash']"/>
        </q-button>

        <q-button
          v-if="getPermissions('STRUCTURE')"
          class="q-toolbar-btn"
          @click.prevent="structureDialog = true"
        >
          <font-awesome-icon :icon="['fas', 'cog']"/>
        </q-button>

        <q-input
          v-model="word"
          :placeholder="this.$qt('listStructure.searchPlaceHolder')"
          :style="searchStyle"
        >
          <q-button
            slot="append"
            type="info"
            icon="q-icon-search"
          />
        </q-input>
      </div>
    </div>

    <q-table
      stripe
      :data="filteredData"
      :width="listStructure.width"
      class="q-composite-list"
      sum-text="----"
      :empty-text="this.$qt('listStructure.emptyList')"
      @row-click="rowSelected"
      @selection-change="handleSelectionChange"
    >
      <q-table-column
        type="selection"
        width="55"
      />
      <q-table-column
        label=""
        width="40"
      />
      <q-table-column
        v-for="col in listStructure.columns"
        :key="col.key"
        :type="col.type"
        :sortable="col.sortable === true"
        :label="col.caption"
        :width="col.width === 0 ? undefined : col.width"
      >
        <template slot-scope="scope">
          <template v-if="col.fieldType === 'DatePicker'">
            <span
              style="direction: ltr"
            >{{ getDate(scope.row[col.key]) }}</span>
          </template>
          <template v-else-if="col.fieldType === 'CheckBox'">
            <font-awesome-icon
              v-if="scope.row[col.key] === true"
              icon="check"
            />
            <font-awesome-icon
              v-else
              icon="times"
            />
          </template>
          <template v-else-if="col.fieldType === 'model'">
            <span>AMIN</span>
          </template>
          <template v-else>
            <span>{{ scope.row[col.key] }}</span>
          </template>
        </template>
      </q-table-column>
    </q-table>

    <q-dialog
      :title="this.$qt('listStructure.settingTitle')"
      width="50%"
      :visible.sync="structureDialog"
    >
      <span slot="footer">
        <q-button
          type="primary"
          @click="updateStructure"
        >{{ this.$qt('listStructure.confirmSetting') }}</q-button>
        <q-button @click="structureDialog = false">{{ this.$qt('listStructure.rejectSetting') }}</q-button>
      </span>
    </q-dialog>

    <q-dialog
      :title="detailDialogTitle"
      width="50%"
      :visible.sync="detailDialog"
      append-to-body
    >
      <q-form
        ref="compositeDetail"
        :model="currentModel"
        :rules="compositeRules"
        label-width="150px"
      >
        <!--        <q-json>{{currentModel}}</q-json>-->
        <!--        <q-json>{{compositeFormStructure}}</q-json>-->
        <q-form-generator
          v-model="currentModel"
          :form-structure="compositeFormStructure"
        />
      </q-form>

      <span slot="footer">
        <q-button
          type="primary"
          @click="detailDialog = false"
        >
          <span>{{ this.$qt('actions.cancel') }}</span>
        </q-button>
        <q-button
          type="primary"
          @click="persist(true)"
        >
          <span>{{ this.$qt('actions.next') }}</span>
        </q-button>
        <q-button
          type="primary"
          @click="persist(false)"
        >
          <span>{{ this.$qt('actions.ok') }}</span>
        </q-button>
      </span>
    </q-dialog>

    <q-dialog
      :title="this.$qt('listStructure.settingTitle')"
      width="50%"
      :visible.sync="structureDialog"
    >
      <div>
        <!--        <list-structure-detail v-model="listStructure" />-->
      </div>
      <span slot="footer">
        <q-button
          type="primary"
          @click="updateStructure"
        >
          {{ this.$qt('listStructure.confirmSetting') }}
        </q-button>
        <q-button
          @click="structureDialog = false"
        >
          {{ this.$qt('listStructure.rejectSetting') }}
        </q-button>
      </span>
    </q-dialog>

    <q-dialog
      :title="this.$qt('model.deleteDialog.title')"
      :visible.sync="deleteDialog"
      width="30%"
      append-to-body
    >
      <span>{{ this.$qt('model.deleteDialog.warningNote') }}</span>
      <span
        slot="footer"
      >
        <q-button
          type="primary"
          @click="deleteModel()"
        >
          {{ this.$qt('model.deleteDialog.confirm') }}
        </q-button>
        <q-button
          @click="deleteDialog = false"
        >
          {{ this.$qt('model.deleteDialog.cancel') }}
        </q-button>
      </span>
    </q-dialog>
  </div>
</template>

<script>
  import listMixin from '../../mixins/listMixin'

  export default {
    name: "QList",

    mixins: [listMixin],
    props: {
      structureKey: {required: true, type: String}
    },

    data() {
      return {
        deleteDialog: false,

        compositeRules: undefined,
        compositeFormStructure: undefined,
        detailDialogTitle: this.$qt('xxx'),
        detailDialog: false,
        currentModel: undefined,

        rangeModel: {}
      }
    },

    computed: {
      isRtl() {
        return this.$qt('direction') === 'rtl';
      },
      searchStyle() {
        const ret = {};
        if (this.isRtl)
          ret.marginRight = '5px';
        else
          ret.marginLeft = '5px';
        return ret;
      },
      firstButtonStyle() {
        const ret = {};
        if (this.isRtl)
          ret.marginRight = '0';
        else
          ret.marginLeft = '0';
        return ret;
      },
    },

    watch: {},

    mounted() {

      this.$delegate('structure', 'fetchListStructure', {
        structureKey: this.structureKey
      }).then((res1) => {
        this.listStructure = res1.result;
        this.$delegate('structure', 'fetchFormStructure', {
          structureKey: this.listStructure.detailFormKey
        }).then((res) => {
          this.compositeFormStructure = res.result;
        }).catch(() => {
        });
      }).catch(() => {
      });
    },

    methods: {



      rowSelected(row) {
        if (this.disabled)
          return;

        this.detailDialog = true;
        this.currentModel = this.$tools.clone(row);
      },
      newComposite() {
        this.currentModel = {};
        this.currentModel.runtimeId = 0;
        this.detailDialog = true;
      },
      deleteModel() {
        this.deleteDialog = false;

        for (let i in this.multipleSelection) {
          let index = this.models.indexOf(this.multipleSelection[i]);
          if (index > -1) {
            this.models.splice(index, 1);
          }
        }

        this.word = undefined;
        this.inspectData();
      },
      setCompositeRules(rules) {
        this.compositeRules = rules;
      },
      updateList(_model) {
        if (_model.runtimeId === 0) {
          _model.runtimeId = this.$tools.getRandomRuntimeId();
          if (!this.models)
            this.models = [];

          this.models.push(_model);
        } else {
          let list = this.$tools.cloneList(this.models);
          for (let i = 0, len = list.length; i < len; i++) {
            if (list[i].runtimeId === _model.runtimeId) {
              list[i] = _model;
            }
          }
          this.models = list;
        }
        this.word = undefined;
        this.inspectData();
      },
      persist(next) {
        this.$refs['compositeDetail'].validate((valid) => {
          if (valid) {
            let _model = this.$tools.clone(this.currentModel);
            if (_model) {
              setTimeout(() => {
                this.updateList(_model);
              }, 3);
              setTimeout(() => {
                if (next) {
                  this.currentModel = {};
                  this.currentModel.runtimeId = 0;
                  this.detailDialog = true;
                } else {
                  this.detailDialog = false;
                }
              }, 5);
            }
          } else {
            return false;
          }
        });
      }
    }
  }

</script>

<style scoped>
  .q-composite-container {
    background-color: #fff;
    border: 1px solid #cfdbe2;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
    border-radius: 4px;
    margin: 1px;
    padding: 15px;
  }

  .q-toolbar {
    margin-bottom: 20px;
  }

  .q-composite-list {

    margin: 0;
  }

  .q-toolbar-buttons {
    display: -webkit-box;
    display: -ms-flexbox;

    display: flex;
    line-height: 15px;
  }

  .q-toolbar-btn {
    margin-left: 3px;
    margin-right: 3px;
  }
</style>